<template>
  <div class="scroll_wrap">
    <div class="en_tit">{{business.info.en}}</div>
    <div class="scroll_tit">{{business.info.title}}</div>
    <!-- <div class="card_content gktp">
      <div class="center-box">
        <swiper ref="mySwiper" :options="swiperOption">
          <swiper-slide class="box-slide" v-for="(item, index) in business.list" :key="index">
            <div class="card" @mouseenter="showMask(index)" @mouseleave="hideMask">
              <img :src="item.img" alt="" />
              <div class="card_text" v-show="currentIndex === index" @click="$router.push({path:'/news/index',query:{type:item.slug}})">
                <div class="card_tit">{{ item.title }}</div>
                <div class="card_subtitle">{{ item.subtitle }}</div>
                <div class="card_desc">{{ item.describe }}</div>
                <div class="card_btn">详情</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="czBtn">
        <div class="swiper-button-prev domain-prev" slot="button-prev">
          
        </div>
        <div class="swiper-button-next domain-next" slot="button-next">
          
        </div>
      </div>
    </div> -->
    <div class="card_content gktp pc_container">
      <div class="center-box" style="height: 556px; overflow: hidden;">
        <div ref="mySwiper" :options="swiperOption" style="display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap">
          <div class="box-slide" v-for="(item, index) in business.list" :key="index">
            <div class="card" @mouseenter="showMask(index)" @mouseleave="hideMask">
              <el-image :src="item.img" fit="cover" lazy />
              <div class="card_text" v-show="currentIndex === index" @click="$router.push({path:'/news/index',query:{type:item.slug}})">
                <div class="card_tit">{{ item.title }}</div>
                <div class="card_subtitle">{{ item.subtitle }}</div>
                <div class="card_desc">{{ item.describe }}</div>
                <div class="card_btn">详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
export default {
  props: {
    business: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      currentIndex: null,
      swiperOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 29,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        navigation: {
          nextEl: '.domain-next',
          prevEl: '.domain-prev'
        }
      }


    }
  },
  methods: {
    showMask(index){
      this.currentIndex = index;
    },
    hideMask(){
      this.currentIndex = null;
    }
  },
}
</script>

<style lang="scss" scoped>
.scroll_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;
  background: #fff;

  .en_tit {
    font-family: SourceHanSansCN-Bold, SourceHanSansCN-Bold;
    font-size: 48px;
    color: #DCDCDC;
    text-transform: uppercase;
  }

  .scroll_tit {
    font-family: SourceHanSansCN-Bold, SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top: -15px;
    position: relative;
    &::after {
      content: '';
      display: block;
      background: #000;
      margin: 0 auto;
      width: 60px;
      height: 5px;
      background: #006DE8;
      margin-top: 13px;
    }
  }

  .gktp {
    .center-box {
      margin-top: 30px;
      width: 100%;
      position: relative;
      .box-slide{
        width: 32%;
      }

      .card {
        height: 556px;
        width: 100%;
        position: relative;
        .el-image {
          width: 100%;
          height: 100%;
        }
        
        .card_text {
          position: absolute;
          cursor: pointer;
          // bottom: 0;
          left: 0;
          width: 100%;
          height: 556px;
          background: rgba(0, 0, 0, .6);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          color: #fff;
          top: -469px; /* 开始时元素在上方 */
          animation: slide-down 0.8s forwards; /* 应用动画 */
          .card_tit {
            font-size: 36px;
            font-family: SourceHanSansCN-Regular;
            color: #FFF;
          }

          .card_subtitle {
            font-size: 18px;
            font-family: SourceHanSansCN-Regular;
            color: #FFF;
            margin-top: 20px;
          }

          .card_desc {
            font-size: 20px;
            font-family: Source Han Sans CN;
            color: #FFF;
            margin-top: 95px;
            padding: 20px;
          }
          .card_btn {
            width: 174px;
            height: 48px;
            line-height: 48px;
            border: 2px solid #247BF4;
            font-size: 20px;
            color: #247BF4;
            margin-top: 70px;
          }
        }
      }
    }

    .czBtn {
      width: 120px;
      height: 45px;
      margin: 0 auto;
      margin-top: 69px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .swiper-button-next,
      .swiper-button-prev {
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, .6);
        color:#fff;
        width: 44.5px;
        height: 44.5px;
        z-index: 9;
      }
      .swiper-button-next:after, .swiper-button-prev:after {
        font-size: 20px;
      }
      .swiper-button-next:hover, .swiper-button-prev:hover {
        background: #2A59AB;
      }
    }
  }

  @keyframes fade-in-out {
      from {
          opacity: 0;
      }
      to {
          opacity: 1;
      }
  }

  @keyframes slide-down {
    to {
      top: 0; /* 动画结束时元素在原来位置 */
    }
  }
}
</style>